<template>
    <div class="qty-wrap" :class="cssClasses" :id="'qty-wrap' + sizeTitle">
        <div class="controls-container controls-container--decriment" @click="decriment()">
            <span class="minus-qty"> - </span>
        </div>
        <input
            class="size-row__input"
            :ref="'bundle-single-product-' + prId"
            :id="prId"
            :name="'size-qty-' + sizeTitle"
            maxlength="12"
            :value="value"
            @change="onChange($event.target.value, 'bundle-single-product-' + prId)"
            @click="$event.target.select()"
            type="number"
        >

        <div class="controls-container controls-container--incriment" @click="increment()">
            <span class="plus-qty"> + </span>
        </div>
        <label class="custom-qty-label" v-if="isTitleDisplay()" :for="'qty-wrap' + sizeTitle">
            <span class="label-text">{{ sizeTitle }}</span>
            <span class="sub_upcharge"> {{ store.inputProductData.sizeUpcharge[sizeTitle] !== undefined ? '+$' + store.inputProductData.sizeUpcharge[sizeTitle].toFixed(2) : '' }}</span>
        </label>
    </div>

</template>

<script>
import { store } from './store'

export default {
    props: {
        sizeTitle: String,
        modelValue: {
            type: String,
            required: true
        },
        lineId: Number,
        cssClasses: {
            type: String,
            required: false
        },
        displayTitle: { 
          type: Boolean,
          required: false
        },
        prId: {
          type: String,
          required: false
        }
    },

    data() {
        return {
            store: store,
            qtyVal: 0,
            qtyError: null,
            maxQty: 10000,
            minQty: 0
        }
    },
    computed: {
        value: {
            get() {
                if (store.productType === 'grouped_plain') {
                    this.setDefaultQtyForLine();
                }
                let val = this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle]
                    ? this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle]
                    : this.minQty;

                if(val < 0) {
                    val = 0;
                }

                return val;
            },
            set(value) {
                if(value < 0) {
                    value = 0;
                }

                this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle] = "";
                this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle] = value;
            }
        }
    },
    methods: {
        isTitleDisplay() {
            let display = false;

            if(this.store.productType == 'grouped_apparel' && this.store.application_type == 'default') {
                display = true;
            } else if(this.store.productType == 'grouped_plain') {
                display = false;
            }

            if(this.displayTitle === true ) {
                display = true;
            }
            console.error("#######################             Qty title display               >>>>");
            console.warn(this.displayTitle);
            console.warn(typeof this.displayTitle);
            console.warn(this.store.productType);
            console.warn(this.store.application_type);
            return display;
        },
        setDefaultQtyForLine() {
            let result = false;
            if (store.productType === 'grouped_plain') {
                if(this.store.inputProductData.minOrderQty && !this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes.qty) {
                    this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes.qty = this.store.inputProductData.minOrderQty;
                    result = true;
                }
            }
            return result;
        },
        increment() {
            console.error("Incriment clicked");
            this.value = Number(this.value);
            this.store.inputProductData.qtyIncrement = Number(this.store.inputProductData.qtyIncrement);
            if (this.value < this.maxQty) {
                if (this.qtyError) {
                    let remainder = this.value % this.store.inputProductData.qtyIncrement;
                    this.value = this.value + this.store.inputProductData.qtyIncrement - remainder;
                    this.qtyError = null;
                } else {
                    this.value = this.value + this.store.inputProductData.qtyIncrement;
                }
            } else {
                this.value = Number(this.maxQty);
            }
            this.$emit('customQtyChange', {value: this.value, lineIndex: this.lineId, title: this.sizeTitle});
            this.$emit('showQtyError', {qtyError: this.qtyError});
            this.store.qtyError = this.qtyError;
        },
        decriment() {
            if(this.minQty < 0) {
                this.minQty = 0;
            }
            this.value = Number(this.value);

            //this.minQty = (this.minQty != 0) ? this.minQty : this.store.inputProductData.qtyIncrement;

            this.store.inputProductData.qtyIncrement = Number(this.store.inputProductData.qtyIncrement);
            if (this.value >= this.minQty) {
                if (this.qtyError) {
                    let remainder =  this.value % this.store.inputProductData.qtyIncrement;
                    this.value =  this.value - remainder;
                    this.qtyError = null;
                } else {
                    this.value = this.value - this.store.inputProductData.qtyIncrement;
                }
            } else {
                this.value = (this.store.productType == 'grouped_apparel') ? 0 : this.store.inputProductData.qtyIncrement;
            }
            // TODO check if need after adding computed prop
            this.$emit('customQtyChange', {value: this.value, lineIndex: this.lineId, title: this.sizeTitle});
            this.$emit('showQtyError', {qtyError: this.qtyError});
            this.store.qtyError = this.qtyError;
        },
        onChange(value, refValue = null) {
            if(this.minQty < 0) {
                this.minQty = 0;
            }
            console.log("change");
            console.log(value);
            value = Number(value);
            this.store.inputProductData.qtyIncrement = Number(this.store.inputProductData.qtyIncrement);

            if (value < 0 || value < this.store.inputProductData.qtyIncrement) {
                value = (this.store.productType == 'grouped_apparel') ? 0 : this.store.inputProductData.qtyIncrement;
            }

            if (value > this.maxQty) {
                value = Number(this.maxQty);
            }

            this.value = value;

            if(this.store.application_type == 'calendar' || this.store.application_type == 'calendar_single') {
                let currValue = 25;
                if(value < 25) {
                    console.warn("if");
                    currValue = 25;

                } else if(value % this.store.inputProductData.qtyIncrement) {
                    console.warn("else if");
                    currValue = this.roundValueBy(value, this.store.inputProductData.qtyIncrement);
                }

                if(value > 25 && !(value % this.store.inputProductData.qtyIncrement)) {
                    currValue = value;
                }

                this.value = currValue;
                this.$refs[refValue].value = currValue;
                this.$emit('customQtyChange', {value: currValue, lineIndex: this.lineId, title: this.sizeTitle});

            } else {
                if (this.validateInputQty(value)) {
                    this.$emit('customQtyChange', {value: value, lineIndex: this.lineId, title: this.sizeTitle});
                }
            }
        },
        roundValueBy(value, by) {
            return Math.round(parseInt(value) / parseInt(by)) * parseInt(by);
        },
        validateInputQty(value){
            const  increment =  this.store.inputProductData.qtyIncrement;
            let result  =  true;
            let failCondition = value < increment || value % increment != 0 || !Number.isInteger(value);

            if(failCondition){
                result = false;
            }

            if(!result){
                this.qtyError = "Item purchasable in increments of " + increment;

                result = false;
            }else{
                this.qtyError = null;
            }

            this.store.qtyError = this.qtyError;
            this.$emit('showQtyError', {qtyError: this.qtyError});

            return result;
        },

    },
    created() {
        console.error(">>>>>>created custom QTY>>>>>>>");
        if(this.store.application_type == "calendar_single" || this.store.application_type == "calendar"){
            this.minQty = 25;

            if(window.jQuery("#calendar-qty-changed")) {
                window.jQuery("body").on("click","#calendar-qty-changed",
                    (event)=> {
                        console.log(event);
                        console.warn("custom qty created hook ");
                        if(window.jQuery("#calendar-imprint-common-qty")) {
                            console.error(window.jQuery("#calendar-imprint-common-qty").val());
                            this.value = window.jQuery("#calendar-imprint-common-qty").val();
                            this.$emit('customQtyChange', {value: this.value, lineIndex: this.lineId, title: this.sizeTitle});
                        }
                    }
                );
            }
        }
        console.log(this.sizeTitle);
        console.log(this.modelValue);
        console.log(this.lineId);
        this.value = Number(this.modelValue);
        console.log(this.store.totalSizesQty[this.store.imprintKey]);
        if(!this.store.totalSizesQty[this.store.imprintKey]) {
            this.$emit('customQtyChange', null);
        }
        console.error(">>>>>>End created custom QTY>>>>>>>");
    },
    mounted() {
        this.$emit('customQtyChange', {value: this.value, lineIndex: this.lineId, title: this.sizeTitle});
    }
}


</script>

<style>

.bundle-butons__item.bundle-butons__item--qty .custom-qty-label {
  position: absolute;
  top: 0;
  left: 0;
}
.bundle-butons__item.bundle-butons__item--qty .custom-qty-label .label-text {
  font-size: 16px;
  font-family: 'museo-sans', sans-serif;
  font-weight: 300;
}

.bundle-butons-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
}
.bundle-butons-wrapper .bundle-butons__item.bundle-butons__item--qty {
    width: 30%;
    background-color: transparent;
    position: relative;
    padding: 20px 0;
}

.bundle-butons-wrapper .bundle-butons__item.bundle-butons__item--qty .size-row__input {
    margin: 0!important;
    padding: 0!important;
    padding: 0!important;
    min-height: 30px!important;
    max-height: 30px!important;
    height: 30px!important;
}

.bundle-butons-wrapper .bundle-butons__item {
    background-color: #009444;
    padding: 8px 18px 9px;
    font-size: 16px;
    font-family: "Montserrat", sans-serif;
    color: #fff;
    text-transform: uppercase;
    font-weight: 300;
    line-height: 1.5;
    cursor: pointer;
}
.bundle-butons.bundle-butons-wrapper .controls-container {
    min-height: 30px!important;
    max-height: 30px!important;
    min-width: 30px!important;
    max-width: 30px!important;
    width: 30px!important;
    height: 30px!important;
    z-index: 1;
}

.error-qty{
  padding: 5px 10px;
  background: #ff6666;
  color: white;
  font-size: 14px;
  display: inline-block;
  margin-top: 10px;
  width: 100%;
  font-family: 'museo-sans', sans-serif;
}

</style>